import BaseClient from '@/app/model/api/response/baseApiClient'

class ServiceFunctionApi extends BaseClient {
  public getServiceFunctionData () {
    const path = '/v1/service-functions'

    /* 共通処理 */
    return super.doFetch(process.env.VUE_APP_API_URL + path, 'GET')
  }
}

export default new ServiceFunctionApi()
